import { render, staticRenderFns } from "./ProceduresInitUpdate.vue?vue&type=template&id=68767bdd&scoped=true"
import script from "./ProceduresInitUpdate.vue?vue&type=script&lang=js"
export * from "./ProceduresInitUpdate.vue?vue&type=script&lang=js"
import style0 from "./ProceduresInitUpdate.vue?vue&type=style&index=0&id=68767bdd&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68767bdd",
  null
  
)

export default component.exports